import { z } from 'zod';
import { DisplayNameSchema, PasswordSchema, UsernameSchema } from './auth.js';
import { LegalKeySchema } from './legal.js';
/** Open sign-up (doc 64). */
export const SignupFormResponseSchema = z.object({ formToken: z.string(), previewMb: z.number().int() });
export const SignupRequestSchema = z.object({
    username: UsernameSchema,
    displayName: DisplayNameSchema,
    password: PasswordSchema,
    adult: z.literal(true, { message: 'You must be at least 18 years old' }),
    terms: z.literal(true, { message: 'Please accept the terms of use' }),
    formToken: z.string().max(200),
    /** The hidden field: people leave it empty. */
    website: z.string().max(200).optional(),
});
export const AdminSignupResponseSchema = z.object({ open: z.boolean(), missing: z.array(LegalKeySchema) });
export const SetSignupRequestSchema = z.object({ open: z.boolean() });
//# sourceMappingURL=signup.js.map